<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row d-flex justify-content-end">
              <div class="col-auto pr-0 mr-2">
                <CButton v-if="permissions.delivery_types.add" color="success" @click="createProduct()">
                  <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $t('delivery_types.label') }}
                </CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
              sorter
              pagination
            >
              <template #name="{item}">
                <td>
                 {{item.name}}
                </td>
              </template>
              <template #price="{item}">
                <td>
                 ${{item.price}}
                </td>
              </template>
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.delivery_types.read" class="dropdown-item" type="button" @click="showProduct(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.delivery_types.edit" class="dropdown-item" type="button" @click="editProduct(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.delivery_types.delete" class="dropdown-item" type="button" @click="deleteProduct(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPlus } from '@coreui/icons';

export default {
  name: 'Products',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: i18n.t('delivery_types.fields.name') },
        { key: 'price', label: i18n.t('delivery_types.fields.price') },
        { key: 'options', label: i18n.t('button.options') },
      ],
      you: null,
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('delivery_types.search_placeholder'),
        lazy: false,
        external: true
      },
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    showProduct(id) {
      this.$router.push({ name: 'Product', params: {id} });
    },
    editProduct(id) {
      this.$router.push({ name: 'EditProduct', params: {id} });
    },
    deleteProduct(id) {
      this.$swal({
        title: i18n.t('delivery_types.modal.delete.title'),
        html: i18n.t('delivery_types.modal.delete.body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/products/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              'Deleted!',
              'Client has been deleted.',
              'success'
              );
              this.getProducts();
          }).catch(e => {
            this.$swal(
              'Error!',
              e,
              'error'
              );
          });
        }
      });
    },
    createProduct() {
      this.$router.push({ name: 'CreateProduct'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getProducts () {
      axios.get('/api/products?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.items = response.data.products;
      }).catch(error => {
        if (error.response.status === 401) {
          if (error.response.statusText === "Unauthorized") {
            this.$router.push({ path: '/login' });
          } else {
            this.$router.push({ path: '/' });
          }
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    },
    closeOptions() {
      const dropdownElement = document.querySelectorAll(".show");
      dropdownElement.forEach(elem => {
        elem.classList.remove("show");
      });
    },
    importFile() {

    },
    exportFile() {
      axios({ 
        url: '/api/export/products?token=' + localStorage.getItem("api_token"),
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        fileLink.setAttribute('download', 'productos.xls');
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    }
  }
}
</script>
